import { GripHorizontal, Image, LucideMousePointerClick, MessageSquareText } from "lucide-react";
import React, { useState, useRef, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DescriptionBox from "./DescriptionBox";
import ImageBox from "./ImageBox";
import CategorySelector from "./CategorySelector";
import TagsSelector from "./TagsSelector";
import BlogStatusBox from "./BlogStatusBox";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BlogStatusBox2 from "./BlogStatusBox2";
import BlogDescriptionView from "./BlogDescriptionView";
import { decryptToken } from "../utils/getToken";
import { getDecryptedUserFromCookie } from "../utils/getCookie";



// const allTags = [
//     "Technology",
//     "Science",
//     "Art",
//     "Music",
//     "Travel",
//     "Education",
//     "Health",
//     "Sports",
//     "Finance",
//     "Food",
// ];

const makeEmptyRaw = () => ({
    blocks: [
        {
            key: "abcd",
            text: "",
            type: "unstyled",
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {},
        },
    ],
    entityMap: {},
});



const AddBlog = () => {
    const [title, setTitle] = useState("");
    const [sections, setSections] = useState([
        { id: 1, type: "description", content: makeEmptyRaw(), },
    ]);
    const [isImageModalOpen, setIsImageModalOpen] = useState(false);
    const [activeSectionId, setActiveSectionId] = useState(null);
    const textareaRefs = useRef({});
    const sectionRefs = useRef({});
    const [allCategories, setAllCategory] = useState([])
    const [allTags, setAllTags] = useState([])
    const url = process.env.REACT_APP_LINK
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedTags, setSelectedTags] = useState([]);
    const [featureImage, setFeatureImage] = useState(null);
    const [status, setStatus] = useState("Draft");
    const [author, setAuthor] = useState([])
    const [selectedAuthor, setSelectedAuthor] = useState()
    const [isEdit, setIsEdit] = useState(false)
    const navigate = useNavigate();
    const token = decryptToken("accessToken") || ""
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");

    const onDragEnd = (result) => {
        if (!result.destination) return;

        const reorderedSections = Array.from(sections);
        const [movedSection] = reorderedSections.splice(result.source.index, 1);
        reorderedSections.splice(result.destination.index, 0, movedSection);

        setSections(reorderedSections);
    };

    const fetchCategoriesData = async () => {
        try {
            const response = await fetch(`${url}/blog-category`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const res = await response.json();
            setAllCategory(res.data);
        } catch (error) {
            console.log(error);
        }
    }

    const fetchAuthorData = async () => {
        try {
            const response = await fetch(`${url}/blog-author`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const res = await response.json();
            setAuthor(res.data);

            // ✅ If there's only one author, or saved author exists — preselect it
            if (res.data.length === 1) {
                setSelectedAuthor(res.data[0]);
                localStorage.setItem("selectedAuthor", JSON.stringify(res.data[0]));
            }
            // ✅ Restore previously selected author if any
            else {
                const saved = localStorage.getItem("selectedAuthor");
                if (saved) {
                    const parsed = JSON.parse(saved);
                    const match = res.data.find(a => a.id === parsed.id);
                    if (match) setSelectedAuthor(match);
                } else if (res.data.length > 0) {
                    // fallback: select first author
                    setSelectedAuthor(res.data[0]);
                    localStorage.setItem("selectedAuthor", JSON.stringify(res.data[0]));
                }
            }
        } catch (error) {
            console.log(error);
        }
    };




    const fetchTagData = async () => {
        try {
            const response = await fetch(`${url}/blog-tag`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const res = await response.json();
            setAllTags(res.data);
        } catch (error) {
            console.log(error);
        }
    }

    const addSection = (type, content = {}) => {
        const newSection = {
            id: Date.now(),
            type,
            content: type === "description" ? makeEmptyRaw() : {},
            showTooltip: type === "image" ? false : undefined,
        };

        let updatedSections = [...sections];
        let scrollToSection = false;

        // Check if active section is the 2nd section (index 1) and adding description
        if (type === "description" && activeSectionId === sections[1]?.id && sections.length >= 2) {
            // Add description as the 3rd section (index 2)
            updatedSections.splice(2, 0, newSection);

            // Move existing image section (if any) at index 2 to index 3
            const imageSectionIndex = updatedSections.findIndex(
                (s, i) => i === 2 && s.type === "image"
            );
            if (imageSectionIndex !== -1) {
                const [imageSection] = updatedSections.splice(imageSectionIndex, 1);
                updatedSections.splice(3, 0, imageSection);
            }
            scrollToSection = true;
        } else {
            // Default: Add section at the end
            updatedSections.push(newSection);
            scrollToSection = true; // Scroll to new section for all types
        }

        setSections(updatedSections);

        // Scroll to the newly added section for all types
        if (scrollToSection) {
            setTimeout(() => {
                const sectionElement = sectionRefs.current[newSection.id];
                if (sectionElement) {
                    sectionElement.scrollIntoView({ behavior: "smooth", block: "center" });
                }
            }, 100); // Small delay to ensure DOM updates
        }
    };

    const duplicateSection = (id) => {
        const section = sections.find((s) => s.id === id);
        if (section) {
            const newSection = { ...section, id: Date.now() };
            setSections([...sections, newSection]);

            // Scroll to duplicated section for all types
            setTimeout(() => {
                const sectionElement = sectionRefs.current[newSection.id];
                if (sectionElement) {
                    sectionElement.scrollIntoView({ behavior: "smooth", block: "center" });
                }
            }, 100);
        }
    };

    const deleteSection = (id) => {
        if (sections.length === 1 && sections[0].type === "description") {
            alert("At least one description section is required.");
            return;
        }
        setSections(sections.filter((s) => s.id !== id));
        if (activeSectionId === id) {
            setActiveSectionId(null);
        }
    };

    const handleImageSelect = (imageObj, sectionId = null) => {
        if (sectionId) {
            setSections(
                sections.map((s) =>
                    s.id === sectionId
                        ? { ...s, content: { ...s.content, url: imageObj.url, title: s.content.title || "" } }
                        : s
                )
            );
        } else {
            addSection("image", { url: imageObj.url, title: "" });
        }
        setIsImageModalOpen(false);
    };

    const handleDescriptionFocus = (sectionId) => {
        setActiveSectionId(sectionId);
    };

    const handleDescriptionBlur = () => {
        setActiveSectionId(null);
    };


    // const handleSubmit = async (statusBoxPayload) => {
    //   if (!title.trim()) {
    //     toast.error("Please enter a blog title.");
    //     return;
    //   }

    //   const finalPayload = {
    //     title,
    //     author_name: selectedAuthor?.title || "",
    //     feature_image: featureImage?.image || null,
    //     sections,
    // categories: selectedCategory,
    //     tags: selectedTags,
    //     status: statusBoxPayload?.status || "Draft",
    //     visibility: statusBoxPayload?.visibility || "Public",
    //     password:
    //       statusBoxPayload?.visibility === "Password"
    //         ? statusBoxPayload.password
    //         : "",
    //   };

    //   try {
    //     const res = await fetch(`${url}/api/blog`, {
    //       method: "POST",
    //       headers: {
    //         "Content-Type": "application/json",
    //       },
    //       body: JSON.stringify(finalPayload),
    //     });

    //     const data = await res.json();

    //     if (res.ok) {
    //         window.location.href = "/all-blogs";

    //       toast.success(
    //         statusBoxPayload?.status === "Publish"
    //           ? "Blog Published Successfully!"
    //           : "Saved as Draft!",
    //         { position: "top-center", autoClose: 2000 }
    //       );

    //     } else {
    //       toast.error("❌ Failed to save blog: " + data.message);
    //       console.log("Server Response →", data);
    //     }
    //   } catch (err) {
    //     console.error(err);
    //     toast.error("Error saving blog. Check console for details.");
    //   }
    // };


    const handleSubmit = async (statusBoxPayload = {}) => {
        if (!title.trim()) {
            toast.error("Please enter a blog title.");
            return null;
        }

        const cleanedSections = sections.map((sec, index) => ({
            ...sec,
            order: index,
            content: sec.content   // already raw object
        }));




        const finalPayload = {
            title,
            author_name: selectedAuthor?.title || "",
            feature_image: featureImage?.image || null,
            sections: cleanedSections,
            categories: selectedCategory,
            tags: selectedTags,
            status: statusBoxPayload?.status || "Draft",
            visibility: statusBoxPayload?.visibility || "Public",
            password:
                statusBoxPayload?.visibility === "Password"
                    ? statusBoxPayload.password
                    : "",
            // optional: include action so backend knows if fast-preview or publish
            action: statusBoxPayload?.action || null,
        };

        try {
            const res = await fetch(`${url}/blog`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify(finalPayload),
            });

            const data = await res.json();

            if (res.ok) {
                // If caller asked for a publish explicitly, then redirect
                if (finalPayload.status === "Publish" || finalPayload.action === "publish") {
                    // only redirect on actual publish
                    window.location.href = "/blog";
                    toast.success("Blog Published Successfully!", { position: "top-center", autoClose: 2000 });
                } else {
                    if (statusBoxPayload.actionType === "preview") {
                        window.open(`/admin/preview-blog/${data.data.slug}/${data.data.id || "temp"}`, "_blank");
                        window.location.href = (`/edit-blog/${data.data.id}`)
                    } else {
                        window.location.href = "/blog";
                    }
                    // for draft / preview saves: just show success toast and return server data
                    toast.success("Saved as Draft!", { position: "top-center", autoClose: 1200 });
                }

                return data; 
            } else {
                toast.error("❌ Failed to save blog: " + (data.message || "Server error"));
                console.log("Server Response →", data);
                return null;
            }
        } catch (err) {
            console.error(err);
            toast.error("Error saving blog. Check console for details.");
            return null;
        }
    };

    useEffect(() => {
        fetchCategoriesData();
        fetchTagData();
        fetchAuthorData();
    }, [])

    return (
        <div className="p-2 flex items-start gap-2">
            <div className="flex-[2] w-full shrink-0">
                <div className="p-4 bg-white shadow-md rounded-lg">
                    <input
                        type="text"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        placeholder="Enter blog title"
                        className="w-full border-b-2 border-gray-300 focus:border-indigo-500 outline-none py-2 transition text-xl"
                    />
                    {/* <p
                        className="text-sm text-gray-800 font-normal tracking-wide mt-3 cursor-pointer break-all"
                        onClick={() => window.open("https://www.w3.org/Provider/Style/dummy.html", "_blank")}
                    >
                        Blog URL:{" "}
                        <span className="hover:underline">
                            https://www.w3.org/Provider/Style/dummy.html
                        </span>
                    </p> */}
                </div>

                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="sections">
                        {(provided) => (
                            <div {...provided.droppableProps} ref={provided.innerRef}>
                                {sections.map((section, index) => (
                                    <Draggable key={section.id} draggableId={String(section.id)} index={index}>
                                        {(provided) => (
                                            <div
                                                ref={(el) => {
                                                    provided.innerRef(el);
                                                    sectionRefs.current[section.id] = el;
                                                }}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                className="p-4 bg-white mt-4 shadow-md rounded-lg"
                                            >
                                                <div className="text-gray-300 flex justify-center items-center opacity-80">
                                                    <GripHorizontal />
                                                </div>
                                                {section.type === "description" && (
                                                    <div>
                                                        <DescriptionBox
                                                            content={section.content}
                                                            onChange={(value) => {
                                                                setSections((prev) =>
                                                                    prev.map((s) => {
                                                                        if (s.id !== section.id) return s;

                                                                        // prevent unnecessary updates
                                                                        if (JSON.stringify(s.content) === JSON.stringify(value)) {
                                                                            return s; // no change
                                                                        }

                                                                        return { ...s, content: value };
                                                                    })
                                                                );
                                                            }}



                                                            textareaRef={(el) => (textareaRefs.current[section.id] = el)}
                                                            onFocus={() => handleDescriptionFocus(section.id)}
                                                            onBlur={handleDescriptionBlur}
                                                        />
                                                        <BlogDescriptionView
                                                            key={section.id}
                                                            raw={section.content}
                                                        />
                                                        <div className="flex justify-start gap-1 items-center text-gray-700 font-medium">
                                                            <button
                                                                onClick={() => duplicateSection(section.id)}
                                                                className="flex items-center gap-1 px-2 py-1 rounded cursor-pointer transition"
                                                            >
                                                                <span className="text-indigo-500 font-semibold text-sm hover:underline">
                                                                    Duplicate
                                                                </span>
                                                            </button>
                                                            <div className="w-0.5 h-4 bg-gradient-to-b from-gray-400 via-gray-300 to-gray-400 rounded-full"></div>
                                                            <button
                                                                onClick={() => deleteSection(section.id)}
                                                                className="flex items-center gap-1 px-2 py-1 rounded cursor-pointer transition"
                                                            >
                                                                <span className="text-red-500 font-semibold text-sm hover:underline">Delete</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                                {section.type === "image" && (
                                                    <div>
                                                        <input
                                                            type="text"
                                                            value={section.content.title}
                                                            onChange={(e) => {
                                                                setSections(
                                                                    sections.map((s) =>
                                                                        s.id === section.id
                                                                            ? { ...s, content: { ...s.content, title: e.target.value } }
                                                                            : s
                                                                    )
                                                                );
                                                            }}
                                                            placeholder="Enter image title"
                                                            className="w-full border-b-2 border-gray-300 focus:border-indigo-500 outline-none py-2 transition text-sm sm:text-base"
                                                        />
                                                        <div className="my-3 flex justify-center items-center">
                                                            <ImageBox
                                                                selectedImages={section.content.images || []}
                                                                mode="multi"  // <-- array
                                                                onSelect={(arr) => {
                                                                    setSections((prev) =>
                                                                        prev.map((s) =>
                                                                            s.id === section.id
                                                                                ? { ...s, content: { ...s.content, images: arr } }
                                                                                : s
                                                                        )
                                                                    );
                                                                }}
                                                                onDelete={(idx) => {
                                                                    if (idx === undefined) {
                                                                        // called when "Delete All" is pressed
                                                                        setSections((prev) =>
                                                                            prev.map((s) =>
                                                                                s.id === section.id
                                                                                    ? { ...s, content: { ...s.content, images: [] } }
                                                                                    : s
                                                                            )
                                                                        );
                                                                        return;
                                                                    }
                                                                    const newArr = (section.content.images || []).filter((_, i) => i !== idx);
                                                                    setSections((prev) =>
                                                                        prev.map((s) =>
                                                                            s.id === section.id
                                                                                ? { ...s, content: { ...s.content, images: newArr } }
                                                                                : s
                                                                        )
                                                                    );
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="flex justify-start gap-1 items-center text-gray-700 font-medium">
                                                            <button
                                                                onClick={() => duplicateSection(section.id)}
                                                                className="flex items-center gap-1 px-2 py-1 rounded cursor-pointer transition"
                                                            >
                                                                <span className="text-indigo-500 font-semibold text-sm hover:underline">
                                                                    Duplicate
                                                                </span>
                                                            </button>
                                                            <div className="w-0.5 h-4 bg-gradient-to-b from-gray-400 via-gray-300 to-gray-400 rounded-full"></div>
                                                            <button
                                                                onClick={() => deleteSection(section.id)}
                                                                className="flex items-center gap-1 px-2 py-1 rounded cursor-pointer transition"
                                                            >
                                                                <span className="text-red-500 font-semibold text-sm hover:underline">Delete</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                                {section.type === "button" && (
                                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                        <input
                                                            type="text"
                                                            value={section.content.text}
                                                            onChange={(e) => {
                                                                setSections(
                                                                    sections.map((s) =>
                                                                        s.id === section.id ? { ...s, content: { ...s.content, text: e.target.value } } : s
                                                                    )
                                                                );
                                                            }}
                                                            placeholder="Enter button text"
                                                            className="w-full border-b-2 border-gray-300 focus:border-indigo-500 outline-none py-2 transition text-sm sm:text-base"
                                                        />
                                                        <input
                                                            type="text"
                                                            value={section.content.action}
                                                            onChange={(e) => {
                                                                setSections(
                                                                    sections.map((s) =>
                                                                        s.id === section.id ? { ...s, content: { ...s.content, action: e.target.value } } : s
                                                                    )
                                                                );
                                                            }}
                                                            placeholder="Enter button action (e.g., URL or function)"
                                                            className="w-full border-b-2 border-gray-300 focus:border-indigo-500 outline-none py-2 transition text-sm sm:text-base"
                                                        />
                                                        <div className="flex justify-start gap-1 items-center text-gray-700 font-medium">
                                                            <button
                                                                onClick={() => duplicateSection(section.id)}
                                                                className="flex items-center gap-1 px-2 py-1 rounded cursor-pointer transition"
                                                            >
                                                                <span className="text-indigo-500 font-semibold text-sm hover:underline">
                                                                    Duplicate
                                                                </span>
                                                            </button>
                                                            <div className="w-0.5 h-4 bg-gradient-to-b from-gray-400 via-gray-300 to-gray-400 rounded-full"></div>
                                                            <button
                                                                onClick={() => deleteSection(section.id)}
                                                                className="flex items-center gap-1 px-2 py-1 rounded cursor-pointer transition"
                                                            >
                                                                <span className="text-red-500 font-semibold text-sm hover:underline">Delete</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>

                {isImageModalOpen && (
                    <ImageBox
                        selectedImage={{ image: "" }}   // ⚡ force single-image mode
                        onSelect={(img) => {
                            handleImageSelect(img);
                            setIsImageModalOpen(false);
                        }}
                        onDelete={() => setIsImageModalOpen(false)}
                        onClose={() => setIsImageModalOpen(false)}
                    />
                )}

                <div className="flex justify-center mt-4">
                    <AddTool
                        addSection={addSection}
                        openImageModal={() => setIsImageModalOpen(true)}
                    />
                </div>
            </div>
            <div className="w-full max-w-80 flex-1">
                {/* <div className="p-4 bg-white shadow-md rounded-lg flex flex-col justify-center">
                    <BlogStatusBox onChange={setStatus} handleSubmit={handleSubmit} editing={isEdit} />
                </div> */}
                <div className="p-4 bg-white shadow-md rounded-lg">
                    <BlogStatusBox2 onSuccess={handleSubmit} />
                </div>
                <div className="mt-4 p-4 bg-white shadow-md rounded-lg flex flex-col justify-center">
                    {/* ✅ Blog Status */}


                    {/* ✅ Author Select Box */}
                    <div>
                        <AuthorSelect
                            authors={author}
                            selectedAuthor={selectedAuthor}   // ✅ use selectedAuthor state
                            onSelect={(a) => setSelectedAuthor(a)}  // ✅ allow manual change
                            fetchAuthors={fetchAuthorData}
                        />


                    </div>
                </div>
                {console.log(featureImage)}
                <div className="p-4 bg-white shadow-md rounded-lg flex flex-col justify-center mt-3">
                    <h3 className="text-[16px] font-semibold text-black/80">Feature Image</h3>
                    <span className="pt-2">
                        <ImageBox
                            selectedImage={featureImage}
                            mode="single"     // NEW PROP
                            onSelect={(img) => setFeatureImage(img)}
                            onDelete={() => setFeatureImage(null)}
                        />

                    </span>
                </div>
                <div className="p-4 bg-white shadow-md rounded-lg flex flex-col mt-3">
                    <CategorySelector categories={allCategories} onSelect={setSelectedCategory} selected={selectedCategory} />
                </div>
                <div className="p-4 bg-white shadow-md rounded-lg flex flex-col mt-3">
                    <TagsSelector tags={allTags} onChange={setSelectedTags} />
                </div>
            </div>
        </div>
    );
};

const AddTool = ({ addSection, openImageModal }) => {
    return (
        <div className="bg-white p-2 rounded-lg inline-flex justify-center items-center gap-4 shadow-md cursor-pointer fixed bottom-4 left-1/2 -translate-x-1/2">
            <button
                className="flex items-center gap-1 p-2 hover:bg-indigo-100 rounded transition"
                title="Add Description"
                onClick={() => addSection("description")}
            >
                <MessageSquareText />
            </button>
            <button
                className="flex items-center gap-1 p-2 hover:bg-indigo-100 rounded transition cursor-pointer"
                title="Add Image"
                onClick={() => addSection("image")}
            >
                <Image />
            </button>
            <button
                className="flex items-center gap-1 p-2 hover:bg-indigo-100 rounded transition cursor-pointer"
                title="Add Button"
                onClick={() => addSection("button", { text: "", action: "" })}
            >
                <LucideMousePointerClick />
            </button>
        </div>
    );
};
// const AuthorSelect = ({ authors = [], onSelect, fetchAuthors }) => {
//     const [search, setSearch] = useState("");
//     const [filteredAuthors, setFilteredAuthors] = useState(authors);
//     const [selectedAuthor, setSelectedAuthor] = useState(null);
//     const [isOpen, setIsOpen] = useState(false);
//     const dropdownRef = useRef(null);

//     // ✅ Fetch authors if not loaded
//     useEffect(() => {
//         if (!authors.length && fetchAuthors) fetchAuthors();
//     }, [authors, fetchAuthors]);

//     // ✅ Filter authors on search
//     useEffect(() => {
//         if (authors.length > 0) {
//             setFilteredAuthors(
//                 authors.filter((a) =>
//                     a.title.toLowerCase().includes(search.toLowerCase())
//                 )
//             );
//         }
//     }, [search, authors]);

//     // ✅ Close dropdown when clicking outside
//     useEffect(() => {
//         const handleClickOutside = (e) => {
//             if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
//                 setIsOpen(false);
//             }
//         };
//         document.addEventListener("mousedown", handleClickOutside);
//         return () => document.removeEventListener("mousedown", handleClickOutside);
//     }, []);

//     const handleSelect = (author) => {
//         setSelectedAuthor(author);
//         if (onSelect) onSelect(author);
//         setIsOpen(false); // close dropdown
//         setSearch(""); // clear search
//     };

//     return (
//         <div className="relative" ref={dropdownRef}>
//             <label className="text-[15px] font-semibold text-gray-800 mb-1 block">
//                 Author
//             </label>

//             {/* Selected Author / Search Box */}
//             <div
//                 onClick={() => setIsOpen((prev) => !prev)}
//                 className="border border-gray-300 rounded-lg px-3 py-2 flex justify-between items-center text-sm cursor-pointer bg-white focus-within:ring-2 focus-within:ring-blue-400"
//             >
//                 {selectedAuthor ? (
//                     <span>{selectedAuthor.title}</span>
//                 ) : (
//                     <input
//                         type="text"
//                         value={search}
//                         onChange={(e) => {
//                             setSearch(e.target.value);
//                             setIsOpen(true);
//                         }}
//                         placeholder="Search author..."
//                         className="outline-none w-full bg-transparent"
//                     />
//                 )}
//                 <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     className={`h-4 w-4 transition-transform ${isOpen ? "rotate-180" : ""
//                         }`}
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                 >
//                     <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth="2"
//                         d="M19 9l-7 7-7-7"
//                     />
//                 </svg>
//             </div>

//             {/* Dropdown List */}
//             {isOpen && (
//                 <div className="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-40 overflow-y-auto">
//                     {filteredAuthors.length > 0 ? (
//                         filteredAuthors.map((author) => (
//                             <div
//                                 key={author.id}
//                                 onClick={() => handleSelect(author)}
//                                 className="px-3 py-2 text-sm hover:bg-blue-100 cursor-pointer"
//                             >
//                                 {author.title}
//                             </div>
//                         ))
//                     ) : (
//                         <p className="text-gray-400 text-sm px-3 py-2">No authors found</p>
//                     )}
//                 </div>
//             )}
//         </div>
//     );
// };


const AuthorSelect = ({ authors = [], selectedAuthor, onSelect, fetchAuthors }) => {
    const [search, setSearch] = useState("");
    const [filteredAuthors, setFilteredAuthors] = useState(authors);
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    // ✅ Fetch authors if not loaded
    useEffect(() => {
        if (!authors.length && fetchAuthors) fetchAuthors();
    }, [authors, fetchAuthors]);

    // ✅ Automatically select first author if only one exists
    useEffect(() => {
        if (authors.length === 1 && !selectedAuthor) {
            onSelect(authors[0]);
        }
    }, [authors, selectedAuthor, onSelect]);

    // ✅ Filter authors on search
    useEffect(() => {
        if (authors.length > 0) {
            setFilteredAuthors(
                authors.filter((a) =>
                    a.title.toLowerCase().includes(search.toLowerCase())
                )
            );
        }
    }, [search, authors]);

    // ✅ Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleSelect = (author) => {
        onSelect(author);
        setIsOpen(false);
        setSearch("");
    };

    return (
        <div className="relative" ref={dropdownRef}>
            <label className="text-[15px] font-semibold text-gray-800 mb-1 block">
                Author
            </label>

            {/* Dropdown input / selected display */}
            <div
                onClick={() => setIsOpen((prev) => !prev)}
                className="border border-gray-300 rounded-lg px-3 py-2 flex justify-between items-center text-sm cursor-pointer bg-white"
            >
                <span>{selectedAuthor ? selectedAuthor.title : "Select author"}</span>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={`h-4 w-4 transition-transform ${isOpen ? "rotate-180" : ""}`}
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
            </div>

            {/* Dropdown menu */}
            {isOpen && (
                <div className="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-40 overflow-y-auto">
                    {filteredAuthors.length > 0 ? (
                        filteredAuthors.map((author) => (
                            <div
                                key={author.id}
                                onClick={() => handleSelect(author)}
                                className={`px-3 py-2 text-sm cursor-pointer hover:bg-blue-100 ${selectedAuthor?.id === author.id ? "bg-blue-50 font-semibold" : ""
                                    }`}
                            >
                                {author.title}
                            </div>
                        ))
                    ) : (
                        <p className="text-gray-400 text-sm px-3 py-2">No authors found</p>
                    )}
                </div>
            )}
        </div>
    );
};



export default AddBlog;